import HttpClienteToken from '../../services/HttpClientToken';

import { TipoParteProps } from '../../interfaces/catalogos/TipoParteInterface';

export const TipoParte = () => {

    return new Promise<TipoParteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoParte/', token)
            .then( ({ data } : { data : TipoParteProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoParte = () => {

    return new Promise<TipoParteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoParte/ObtenerTipoParte', token)
            .then( ({ data } : { data : TipoParteProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoParte = ( params: TipoParteProps ) => {

    return new Promise<TipoParteProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoParte/Actualizar', params, token)
            .then( ({ data } : { data : TipoParteProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoParte: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoParte = ( params: TipoParteProps ) => {

    return new Promise<TipoParteProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoParte/Agregar', params, token)
            .then( ({ data } : { data : TipoParteProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoParte: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}